/* ==========================================================================
   Swaballs Product Page behaviour (classic script, one instance per .sw-pdp).
   - Variant selection → updates .sw-add data-variant-id, price, stock, image
   - Quantity stepper → updates .sw-add data-quantity
   - Gallery thumbnail swap (crossfade)
   - Sticky mobile add-to-cart bar (shows when the buy row scrolls out of view)
   Add-to-cart itself is handled by the existing global sw-cart.js (.sw-add) →
   the existing custom cart drawer. This file does NOT touch those.
   ========================================================================== */
(function () {
  'use strict';

  var MONEY = (window.SW && window.SW.moneyFormat) || '${{amount}}';
  function formatMoney(cents) {
    cents = cents || 0;
    function commas(n) { return n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'); }
    function fmt(precision, t, d) {
      var v = (cents / 100.0).toFixed(precision).split('.');
      return commas(v[0]).replace(/,/g, t || ',') + (v[1] ? (d || '.') + v[1] : '');
    }
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return fmt(2, ',', '.');
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        default: return fmt(2, ',', '.');
      }
    });
  }

  function initPdp(root) {
    if (!root || root.dataset.swPdpReady) return;
    root.dataset.swPdpReady = '1';

    var data = root.querySelector('[data-pdp-variants]');
    var variants = [];
    try { variants = JSON.parse(data ? data.textContent : '[]'); } catch (e) { variants = []; }
    if (!variants.length) return;

    var addBtns = Array.prototype.slice.call(root.querySelectorAll('.sw-add'));
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('.sw-pdp-swatch input'));
    var qtyInput = root.querySelector('.sw-pdp-qty input');
    var priceEls = root.querySelectorAll('.sw-pdp-price');
    var compareEl = root.querySelector('.sw-pdp-compare');
    var saveEl = root.querySelector('.sw-pdp-save');
    var stockEl = root.querySelector('.sw-pdp-stock');
    var mainImg = root.querySelector('.sw-pdp-media img');

    function selectedOptions() {
      var opts = [];
      optionInputs.forEach(function (i) { if (i.checked) opts[parseInt(i.dataset.optionIndex, 10)] = i.value; });
      return opts;
    }
    function findVariant(opts) {
      if (!optionInputs.length) return variants[0];
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }

    function swapMain(src) {
      if (!mainImg || !src || mainImg.src === src) return;
      mainImg.classList.add('sw-pdp-swapping');
      setTimeout(function () { mainImg.src = src; mainImg.classList.remove('sw-pdp-swapping'); }, 180);
    }

    function update() {
      var variant = findVariant(selectedOptions()) || variants.find(function (v) { return v.available; }) || variants[0];
      if (!variant) return;
      var money = formatMoney(variant.price);

      addBtns.forEach(function (b) {
        b.setAttribute('data-variant-id', variant.id);
        if (variant.available) { b.removeAttribute('disabled'); } else { b.setAttribute('disabled', 'disabled'); }
        var lbl = b.querySelector('.sw-pdp-add-label');
        if (lbl) lbl.textContent = variant.available ? (b.getAttribute('data-add-label') || 'Add to cart') : (b.getAttribute('data-sold-label') || 'Sold out');
        var pr = b.querySelector('.sw-pdp-add-price');
        if (pr) pr.textContent = variant.available ? money : '';
      });

      var onSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
      priceEls.forEach(function (el) { el.textContent = money; el.classList.toggle('is-sale', onSale); });
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
          if (saveEl) { saveEl.style.display = ''; saveEl.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price); }
        } else {
          compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }

      if (stockEl) {
        stockEl.classList.toggle('is-out', !variant.available);
        var t = stockEl.querySelector('.sw-pdp-stock-t');
        if (t) t.textContent = variant.available ? (stockEl.getAttribute('data-in') || 'In stock') : (stockEl.getAttribute('data-out') || 'Sold out');
      }

      if (variant.featured_media && variant.featured_media.preview_image) swapMain(variant.featured_media.preview_image.src);
    }

    optionInputs.forEach(function (i) { i.addEventListener('change', update); });

    // Quantity
    function syncQty() { var q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1; addBtns.forEach(function (b) { b.setAttribute('data-quantity', q); }); }
    if (qtyInput) {
      var minus = root.querySelector('.sw-pdp-qty .sw-pdp-minus');
      var plus = root.querySelector('.sw-pdp-qty .sw-pdp-plus');
      if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); syncQty(); });
      if (plus) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; syncQty(); });
      qtyInput.addEventListener('change', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1); syncQty(); });
    }

    // Gallery thumbnails
    root.querySelectorAll('.sw-pdp-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        swapMain(thumb.getAttribute('data-full'));
        root.querySelectorAll('.sw-pdp-thumb').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      });
    });

    // Sticky mobile bar visibility
    var sticky = root.querySelector('.sw-pdp-sticky');
    var anchor = root.querySelector('.sw-pdp-buyrow');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -120px 0px' }).observe(anchor);
    }

    update();
    syncQty();
  }

  function initAll(scope) { (scope || document).querySelectorAll('.sw-pdp').forEach(initPdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { if (e.target) initAll(e.target); });
})();
